import Money from 'common/components/layout/Money';

const SalePrice = (props) => {
  const { variant, settings } = props;
  const price = variant.comparePrice || variant.price;
  if (!variant) {
    return null;
  }
  if (!variant.addToCartPrice) {
    return null;
  }
  if (variant.addToCartPrice >= price) {
    return null;
  }
  return (
    <div className="c7-product__variant__price__sale">
      {variant.actionMessage}{' '}
      <Money number={variant.addToCartPrice} settings={settings} />{' '}
      <span className="c7-product__variant__price__title">per person</span>
    </div>
  );
};

export default SalePrice;
